import React, { useContext, useLayoutEffect, useEffect, useState } from "react";
import { PortalContext } from "App";
import OPOnIframe from "pages/iframe-component/operation-online/OPOnIframe";

const OnlineEmployeeDetail = ({ path, redirectFn }) => {
  const stateContext = useContext(PortalContext);
  const { detailPageState } = stateContext;

  const [employeeId, setEmployeeId] = useState("");

  useLayoutEffect(() => {
    const sessionState = JSON.parse(sessionStorage.getItem("state"));
    if (detailPageState && detailPageState[path]) {
      setEmployeeId(detailPageState[path].employeeId);
    } else if (sessionState && sessionState[path]) {
      setEmployeeId(sessionState[path].employeeId);
    } else {
      if (employeeId == "") setEmployeeId("close");
    }
  }, [detailPageState[path]]);

  useEffect(() => {
    if (employeeId == "close") {
      redirectFn("close", { tabId: path });
    }
  }, [employeeId]);

  // uses /merchant/list with merchantIdRedirect query parameter to redirect into merchant/info with the desired merchantId
  const urlPath = `/online-pay/employee/employee-list${
    employeeId ? "?employeeIdRedirect=" + employeeId : ""
  }`;

  return <OPOnIframe path={urlPath} />;
};

export default React.memo(OnlineEmployeeDetail);
